export enum AnalysisTypeEnum {
  ORBIFY_DEFORESTATION = "Orbify deforestation",
}
